import React, { type JSX } from 'react';

export function LoadingIcon({ className }: { className?: string }): JSX.Element {
  return (
    <svg viewBox="0 0 38 38" className={className} stroke="currentColor" strokeOpacity=".5">
      <g fill="none" fillRule="evenodd">
        <g transform="translate(1 1)" strokeWidth="2">
          <circle strokeOpacity=".3" cx="18" cy="18" r="18" />
          <path d="M36 18c0-9.94-8.06-18-18-18">
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 18 18"
              to="360 18 18"
              dur="1s"
              repeatCount="indefinite"
            />
          </path>
        </g>
      </g>
    </svg>
  );
}
